export type ShellPosture = 'operate' | 'build' | 'calisto'

/**
 * Resolves the shell posture (top-level mode) from the current pathname.
 * Single source of truth shared by AppShell and Sidebar.
 */
export const routePosture = (pathname: string): ShellPosture => {
  if (pathname.startsWith('/studio')) {
    return 'calisto'
  }
  if (pathname.startsWith('/build')) {
    return 'build'
  }
  return 'operate'
}
